import { AccumUnit } from "../../components/Container/ConnectionBlock/types/accumulators";
import { PRICE_PLAN_SOC_TYPE } from "../../constants";
export var isAdditional = function isAdditional(accumulator) {
  return accumulator !== null && accumulator !== void 0 && accumulator.socType ? accumulator.socType.toLowerCase() !== PRICE_PLAN_SOC_TYPE.toLowerCase() : true;
};
export var hasResetDate = function hasResetDate(accumulator) {
  return !!(accumulator !== null && accumulator !== void 0 && accumulator.resetDate);
};
export var isSms = function isSms(accumulator) {
  return (accumulator === null || accumulator === void 0 ? void 0 : accumulator.unit) === AccumUnit.SMS;
};
export var isGb = function isGb(accumulator) {
  return (accumulator === null || accumulator === void 0 ? void 0 : accumulator.unit) === AccumUnit.KBYTE;
};
export var isMinutes = function isMinutes(accumulator) {
  return (accumulator === null || accumulator === void 0 ? void 0 : accumulator.unit) === AccumUnit.SECONDS;
};
export var isPricePlan = function isPricePlan(accumulator) {
  var _accumulator$socType;
  return (accumulator === null || accumulator === void 0 || (_accumulator$socType = accumulator.socType) === null || _accumulator$socType === void 0 ? void 0 : _accumulator$socType.toLowerCase()) === PRICE_PLAN_SOC_TYPE.toLowerCase();
};